import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../axiosBaseQuery";


const meaPoolApi = createApi({
    reducerPath: "core/measurement/pool",
    baseQuery: axiosBaseQuery,
    tagTypes: ["measurementPoolList"],
    endpoints: (builder) =>({
        measurementPoolFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['measurementPoolList'],
            query: (query = '') => ({
                url: "core/measurement/pool" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        measurementPoolCreate: builder.mutation({
            invalidatesTags: ['measurementPoolList'],
            query: (data)=>({url: "core/measurement/pool", method: "POST", data})
        }),
        measurementPoolUpdate: builder.mutation({
            invalidatesTags: ['measurementPoolList'],
            query: (data)=>({url: "/core/measurement/pool/"+data.id, method: "PUT", data})
        }),
        measurementPoolDelete: builder.mutation({
            invalidatesTags: ['measurementPoolList'],
            query: (id)=>({url: "/core/measurement/pool/"+id, method: "DELETE"})
        }),
    })
})

export const { useMeasurementPoolFindAllQuery, useMeasurementPoolCreateMutation, useMeasurementPoolUpdateMutation, useMeasurementPoolDeleteMutation } = meaPoolApi;
export {meaPoolApi};
